import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FC } from 'react';

export type AutoRenewalIneligibilityReason = 'young-driver' | 'end-of-product' | '';

interface RenewalContentProps {
	reason: AutoRenewalIneligibilityReason;
	contactPhoneNumber: string;
}

const AutoRenewalIneligibilityContent: FC<RenewalContentProps> = ({ reason, contactPhoneNumber }) => {
	if (!reason) return null;

	const MESSAGE_MAP = {
		'young-driver': (
			<>
				Your policy will not automatically renew. This means you will not have cover in place after your expiry date.
				However, we will contact you before your policy expires, with a renewal offer, giving you time to consider and
				shop around. If you have already received your renewal offer and would like to accept, please call us on{' '}
				<a href={`tel:${contactPhoneNumber}`}>{contactPhoneNumber}</a> to discuss this further.
			</>
		),
		'end-of-product': (
			<>
				We are unable to automatically renew your policy as due to your age, you no longer meet the insurers criteria.
				This means you will not have cover in place after your expiry date. Please note it is an offence under the Road
				Traffic Act 1988 to leave, drive or otherwise use your vehicle on a public highway without a valid insurance
				cover being in force, therefore please ensure you arrange for alternative cover on expiry of your policy.
			</>
		),
	};

	const message = MESSAGE_MAP[reason];

	if (!message) return null;

	return (
		<Box sx={{ mb: 2 }}>
			<Typography>{message}</Typography>
		</Box>
	);
};
export default AutoRenewalIneligibilityContent;
